import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { DepartamentoRegionResponse } from "../../response/comun/DepartamentoRegionResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Regiones de departamento (gRPC-Web `CatalogosPlataformaService.ListRegiones`). Lista cacheada en memoria toda la sesión (catálogo de solo lectura); dos
 *  llamadas simultáneas comparten el mismo request. */
export class DepartamentoRegionListService {
  static readonly instance = new DepartamentoRegionListService();
  private constructor() {}

  private _cache: DepartamentoRegionResponse[] | null = null;
  private _inflight: Promise<DepartamentoRegionResponse[]> | null = null;

  /** Lista completa (el servidor ya la manda sin eliminados y ordenada). */
  async get(): Promise<DepartamentoRegionResponse[]> {
    if (this._cache) return this._cache;
    if (this._inflight) return this._inflight;
    this._inflight = grpcCall(() => grpcClient(CatalogosPlataformaService).listRegiones({}))
      .then((response) => {
        this._cache = response.items.map((r) => ({ id: r.id, departamentoId: r.departamentoId, nombre: r.nombre, isEliminado: false }));
        return this._cache;
      })
      .finally(() => {
        this._inflight = null;
      });
    return this._inflight;
  }
}
